module.exports = require("./ar-TD.d.ts");